import { ERROR, SUCCESS } from "../constants/types/alertType";
import { isEmpty } from "../utils/helper";
import axios from "../utils/axios";

export const contact = (data, callback) => (dispatch) => {
  axios.post("contact", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: isEmpty(resp.data.message)
            ? "Failed to Send Message"
            : resp.data.message,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to Send Message",
      });
      callback && callback();
    }
  );
};
